function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { useLocation } from 'react-router-dom';
import queryString from 'query-string-for-all';
import qs from 'qs';
export function useGetFilterFromLocation() {
    var defaultFilter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, storedFiltersKey = arguments.length > 1 ? arguments[1] : void 0;
    var location = useLocation();
    var query = location.search.length > 1 ? qs.parse(location.search.slice(1)) : {};
    var storedFilters = storedFiltersKey ? JSON.parse(localStorage.getItem(storedFiltersKey)) : {};
    return _object_spread({}, defaultFilter, query, storedFilters);
}
export function useQueryString() {
    var location = useLocation();
    var query = queryString.parse(location.search, {
        parseBooleans: true,
        parseNumbers: true,
        arrayFormat: 'bracket'
    });
    return _object_spread({}, query);
}
